export default __webpack_public_path__ + "static/media/Grace John.5e296d60.jpg";